import { GroupKey } from '../types/GroupKey';
import { AiConversationSummary } from '../types/SocietyAiAgentPageContextType';

const getGroup = (isoDate: string): GroupKey => {
  const diffDays = (Date.now() - new Date(isoDate).getTime()) / 86_400_000;
  if (diffDays < 1) return 'Today';
  if (diffDays < 7) return 'ThisWeek';
  if (diffDays < 30) return 'ThisMonth';
  return 'Previous';
};

export const groupConversations = (conversations: AiConversationSummary[]) => {
  const order: GroupKey[] = ['Today', 'ThisWeek', 'ThisMonth', 'Previous'];

  const map = Object.fromEntries(
    order.map((k) => [k, [] as AiConversationSummary[]])
  ) as Record<GroupKey, AiConversationSummary[]>;
  conversations.forEach((c) => map[getGroup(c.updatedAt)].push(c));
  return order
    .filter((k) => map[k].length)
    .map((k) => ({ group: k, items: map[k] }));
};
